export default __webpack_public_path__ + "static/media/Medium.01e564ab.eot";